import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '分类浏览',
    links: [
      { label: '典故出处', path: '/category/chuchu' },
      { label: '历史背景', path: '/category/beijing' },
      { label: '文化寓意', path: '/category/yuyi' },
      { label: '诗词传承', path: '/category/chuancheng' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 font-bold text-xl font-heading">
                戟
              </span>
              <span className="font-heading text-xl font-bold">
                黄游下戟
              </span>
            </Link>
            <p className="text-secondary-200 text-sm leading-relaxed max-w-xs">
              深耕中国古典文化，以严谨的学术态度和生动的表达方式，为您全面解析黄游下戟这一经典典故的历史渊源与文化内涵。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-sm mb-4 text-background-50/90">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-secondary-200 hover:text-background-50 text-sm transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-300 text-sm">
            &copy; {new Date().getFullYear()} 黄游下戟文化研究. 保留所有权利.
          </p>
          <p className="text-secondary-400 text-xs">
            致力于中国古典文化的传承与传播
          </p>
        </div>
      </div>
    </footer>
  );
}